import React, { useState, useEffect, useContext } from 'react';
import PdpSummaryViewComponent from 'atoms/PdpSummary/AU/Presentation/PdpSummaryViewComponent';
import {
  isEmptyObject,
  checkAllTrue,
  getPrice,
  getValueByKeyName,
  getLength,
  getTernaryValue,
  getAndCheck,
  getFirstArrayItem,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from '../../Constants/MenuPDPPageConstants';
import { useDispatch, useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import {
  computePrice,
  getItemQuantity,
  getMaxItemCountPerLineItem,
  prodQuantityForCatering,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { MENU_PLP_CONSTANT_DATA } from 'common/utilities/menuPLPModulator';
import { priceRoundoff_value, priceFixed_value, CALORIES, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';

export const getDname = i => {
  if (i?.dname && i?.dname[0]) {
    return i?.dname[0].value;
  }
  return i?.name || 'No Name';
};

const getDeltaPrice = (correctItem, currencyConversionFactor) => {
  let upsizegetPrice = getPrice(correctItem[1].availability[0], currencyConversionFactor).toFixed(priceFixed_value);
  let regularPrice = getPrice(correctItem[0].availability[0], currencyConversionFactor).toFixed(priceFixed_value);
  return upsizegetPrice - regularPrice;
};

const Setupsizeinfodata = (customizable, items, currencySymbol, currencyConversionFactor, kilojoule, pdpPromoPage,pdpDataForUpdateFoodLine) => {
  const { REGULAR_SIZE_TITLE, REGULAR_SIZE_DESC, UPSIZE_TITLE, UPSIZE_DESC } = MENU_PDP_PAGE_CONSTANTS;  
  if(!pdpPromoPage && !pdpDataForUpdateFoodLine?.isProductPromo){
    items = items?.filter((itemData)=>{
    return !itemData?.isHidden
  })
  }
  let upsizeInfoData = [];
  if (customizable) {
    let upsizeextraprice = getDeltaPrice(items, currencyConversionFactor);
    upsizeInfoData = [
      {
        id: items[0]?.id,
        title: `${translateWithI18Next(REGULAR_SIZE_TITLE)}`,
        desc: { itemDesc: `${translateWithI18Next(REGULAR_SIZE_DESC)}` },
      },
      {
        id: items[1]?.id,
        title: `${translateWithI18Next(UPSIZE_TITLE)} (+${currencySymbol}${(+upsizeextraprice).toFixed(2)})`,
        desc: { itemDesc: `${translateWithI18Next(UPSIZE_DESC)}` },
      },
    ];
  } else {
    let itemObj = {};
    items.forEach(item => {
      let price = getPrice(item.availability[0], currencyConversionFactor).toFixed(priceFixed_value);
      let calories = getValueByKeyName(item.additionalProperties, CALORIES);
      itemObj = {
        id: item.id,
        title: getDname(item),
        desc: {
          price: price > 0 ? `${currencySymbol}${price}` : '',
          calories: calories === 0 ? '' : ` ${calories} ${kilojoule}`,
        },
      };
      upsizeInfoData.push(itemObj);
    });
  }
  return upsizeInfoData;
};

const setIsActiveHandler = (customModGrps, modgrps, setIsActive) => {
  const IsActiveData = getAndCheck(customModGrps?.length, modgrps?.length);
  if (IsActiveData) {
    setIsActive(getFirstArrayItem(modgrps)?.id);
  }
};
const ProductSummary = props => {
  const {
    pdpData,
    customModGrps = {},
    isIpad,
    isMobile,
    comboData,
    isStoreClosed,
    isItemDecreased,
    quantityRemovedObject,
    itemStatus,
    prodQuantity,
    quantityUpdate,
    addtoCartClinckHandler,
    setItemStatus,
    setProdQuantity,
    storeTimeZone,
    imageContainerSize,
    pdpbackgroundImageData,
  } = props;
  const {
    dname,
    additionalProperties = {},
    availability,
    modgrps,
    catalogName,
    customizable,
    items = [],
  } = pdpData || {};
  const { EXPAND_ACCORDIAN, IS_OUT_OF_STOCK, OUT_OF_STOCK_TEXT, PDP_ITEM_UPSIZE_ID } = MENU_PDP_PAGE_CONSTANTS;
  const [isActive, setIsActive] = useState('');
  const tenantData = useSelector(data => data.tenantReducer);
  const pdpCateringItemQuantityLimit = tenantData?.componentOptions?.web?.pdp?.pdpCateringItemQuantityLimit;
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const [upsizeInfo, setUpsizeInfo] = useState([]);
  const { TURNED_NO_RESULTS_TEXT } = MENU_PLP_CONSTANT_DATA;
  const dispatch = useDispatch();
  const [summaryData, setSummaryData] = useState({});
  const { veg } = additionalProperties;
  const [showNutritionAllergenModal, setNutritionAllergenModalOpen] = useState(false);
  const [SummaryDataFlag, setSummaryDataFlag] = useState(false);

  const nutritionAllergenHandler = () => {
    setNutritionAllergenModalOpen(true);
  };

  const handleCloseModal = () => {
    setNutritionAllergenModalOpen(false);
  };

  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { currentAccordian },
    pdpPromoPage,
    pdpDataForUpdateFoodLine,
  } = userOrderState;

  useEffect(() => {
    setIsActiveHandler(customModGrps, modgrps, setIsActive);
  }, [customModGrps, modgrps]);

  const IsOutOfStockItem = () => {
    if (itemStatus === IS_OUT_OF_STOCK) {
      return false;
    }
  };
  const setAsActiveLink = (event, id) => {
    if (itemStatus === IS_OUT_OF_STOCK) {
      return false;
    }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    userOrderStateDispatch({ type: EXPAND_ACCORDIAN, value: id });
    const btnElm = document.getElementById('accordion-' + id);
    btnElm?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    setIsActive(id);
  };

  useEffect(() => {
    return () => {
      userOrderStateDispatch({ type: EXPAND_ACCORDIAN, value: '' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getTernaryValue(currentAccordian, setAsActiveLink(null, currentAccordian), '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccordian]);

  const makeItComboHandler = event => {
    getTernaryValue(!IsOutOfStockItem() ? IsOutOfStockItem() : '');
    event.preventDefault();
  };

  const handleProdQuantityForCatering = event => {
    prodQuantityForCatering(event, pdpCateringItemQuantityLimit, setProdQuantity);
  };

  /**
   * method to upsize item
   */
  const upSizeHandler = selected_id => {
    if (userOrderState.pdpItemUpsizeId !== selected_id) {
      userOrderStateDispatch({ type: PDP_ITEM_UPSIZE_ID, value: { pdpItemUpsizeId: selected_id } });
      dispatch(
        fetchItemDetailsAction({
          tenantId: tenantData?.tenantId,
          catalogName: pdpData?.catalogName,
          itemId: selected_id,
        }),
      );
    }
  };
  useEffect(() => {
    if (isEmptyObject(pdpData)) {
      let data =
        items.length > 1
          ? Setupsizeinfodata(
              customizable,
              items,
              tenantData.currencySymbol,
              tenantData.currencyConversionFactor,
              tenantData.kilojoule,
              pdpPromoPage,
              pdpDataForUpdateFoodLine
            )
          : [];
      setUpsizeInfo(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdpData]);

  const getPriceAmount = (customizableInfo, availablePrice, isPdpPromoPage, storeTimeZoneInfo) => {
    let price = computePrice(
      availablePrice,
      tenantData?.currencyConversionFactor,
      isPdpPromoPage,
      pdpData?.id,
      storeTimeZoneInfo,
    );
    if (!customizableInfo && price === 0) {
      setItemStatus(IS_OUT_OF_STOCK);
      return translateWithI18Next(OUT_OF_STOCK_TEXT);
    }
    let roundOffPrice = (Math.round(price * priceRoundoff_value) / priceRoundoff_value).toFixed(priceFixed_value);
    return `${tenantData?.currencySymbol}${roundOffPrice}`;
  };

  useEffect(() => {
    let storeClosedFlag = isStoreClosed !== undefined ? true : false;
    let isActiveFlag = isActive !== undefined ? true : false;
    let conditionToCheck = [
      isEmptyObject(pdpData),
      getLength(items) > 0,
      isActiveFlag,
      Array.isArray(upsizeInfo),
      catalogName?.length > 0,
      isEmptyObject(tenantData),
      storeClosedFlag,
    ];
    if (checkAllTrue(conditionToCheck)) {
      const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
      const { ITEM_QUANTITY: itemQuantity } = MENU_CONSTANT;
      let summaryTemplateObject = {
        servesCount: pdpData?.content?.serves,
        cardId: pdpData.id,
        veg,
        calories: pdpData?.content?.caloricValue,
        modgrps,
        customizable,
        isActive,
        setAsActiveLink,
        isIpad,
        makeItComboHandler,
        comboData,
        price: getPriceAmount,
        catalogs: catalogName,
        upsizeInfo,
        upSizeHandler,
        showAddToCartButton: tenantData?.componentOptions?.web?.pdp?.addToCartButton,
        showMakeItComboButton: tenantData?.componentOptions?.web?.pdp?.makeItComboButton,
        pdpCardObject: {
          prodQuantity,
          userParams,
          quantityUpdate,
          dName: getDname(pdpData),
          maxItemCountPerLineItem: getMaxItemCountPerLineItem(
            pdpPromoPage,
            promoDetails,
            pdpData.id,
            pdpCateringItemQuantityLimit,
          ),
          addtoCartClinckHandler,
          itemStatus,
          currencySymbol: tenantData?.currencySymbol,
          currencyConversion: tenantData?.currencyConversionFactor,
          isMobile,
          itemQuantity: getItemQuantity(pdpPromoPage, promoDetails, pdpData.id, itemQuantity),
          handleProdQuantityForCatering,
          defaultdisposition: tenantData?.authoredContent?.defaultdisposition,
          isItemDecreased,
          quantityRemovedObject,
        },
        availability: pdpData.availability,
        isStoreClosed,
        isItemDecreased,
        kilojoule: tenantData?.kilojoule,
        allergenDetails: pdpData?.content?.allergenInformation,
        nutritionalDetails: pdpData?.content?.nutritionalInformation,
        imageName: pdpData?.content,
        imageContainerSize: imageContainerSize,
        pdpbackgroundImageData: pdpbackgroundImageData,
        isExcluded: pdpData?.isExcluded,
      };
      setSummaryData(summaryTemplateObject);
      setSummaryDataFlag(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dname,
    availability,
    veg,
    catalogName,
    isActive,
    modgrps,
    itemStatus,
    isMobile,
    isIpad,
    comboData,
    userParams,
    upsizeInfo,
    tenantData?.maxItemCountPerLineItem,
    prodQuantity,
    isStoreClosed,
    items,
  ]);

  return getTernaryValue(
    SummaryDataFlag,
    isEmptyObject(summaryData) ? (
      <PdpSummaryViewComponent
        data-testid='pdp-summary-view'
        summaryData={summaryData}
        pdpPromoPage={pdpPromoPage}
        storeTimeZone={storeTimeZone}
        nutritionAllergenHandler={nutritionAllergenHandler}
        showNutritionAllergenModal={showNutritionAllergenModal}
        handleCloseModal={handleCloseModal}
        setNutritionAllergenModalOpen={setNutritionAllergenModalOpen}
      />
    ) : (
      <div className='d-flex justify-content-center'>{translateWithI18Next(TURNED_NO_RESULTS_TEXT)}</div>
    ),
    '',
  );
};

export default ProductSummary;
